import { ThunkAction } from "../types";

import { listTopicsProgress, createTopicProgress } from "../actions";
import { TopicsListRequest, Topic, TopicCreateRequest } from "dialup";

export function listTopics(): ThunkAction {
  return async (dispatch, _, { rpc }) => {
    try {
      dispatch(listTopicsProgress.request());

      const resp = await rpc.TopicsList({
        limit: 1000,
      } as TopicsListRequest);

      dispatch(listTopicsProgress.success(resp));
    } catch (err) {
      dispatch(listTopicsProgress.failure(err));
    }
  };
}

const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      if (r.result === null) {
        reject("no result");
        return;
      }
      let encoded = r.result.toString().replace(/^data:(.*,)?/, "");
      if (encoded.length % 4 > 0) {
        encoded += "=".repeat(4 - (encoded.length % 4));
      }
      resolve(encoded);
    };
    r.onerror = err => reject(err);
    r.readAsDataURL(file);
  });

export function createTopic(topic: Topic, file: File): ThunkAction {
  return async (dispatch, _, { rpc }) => {
    try {
      dispatch(createTopicProgress.request());

      const data = await fileToBase64(file);

      const reply = await rpc.TopicsCreate({
        topic,
        data,
      } as TopicCreateRequest);

      dispatch(createTopicProgress.success(reply));
    } catch (err) {
      dispatch(createTopicProgress.failure(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/thunks/topicThunks.ts